import { connect } from 'react-redux';
import { selectCurrentMembershipCountry } from '@redux/modules/user';
import App from './App';

export default connect(state => ({
  currentMembershipCountry: selectCurrentMembershipCountry(state),
}))(App);
